import axios from 'axios';

export default defineNuxtPlugin(({ provide }) => {
  const client = axios.create({
    baseURL: useRuntimeConfig().public.activeStorageURL,
  });
  provide('download', async function (path, fileName = 'users.csv') {
    const blobData = await client.get(this.file ? this.file['file-url'] : path, { responseType: 'blob' });
    const blob = new Blob([blobData.data], { type: 'application/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
    return client.get(path);
  });
});
